















import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import JsonResource from "@/components/common/Debug/JsonResource.vue";
import Customer from "@/views/Service/TimeTracking/Customers/Overview/Customer.vue";

const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';
const NAMESPACE_TIME_TRACKING_CUSTOMERS: string = 'timeTrackingCustomers';
const RESOURCE_TIME_TRACKING_CUSTOMERS: string = 'tt/customers';
@Component({
  components: {Customer, JsonResource}
})
export default class Customers extends Vue {
  public name: string = "Customers.vue";

  @Action('load', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) loadCustomersAction: any;

  @Getter('getDataList', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) getCustomersList: any;
  @Getter('isLoading', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) isLoading: any;

  private carousel: number = 0;

  private loadCustomersView(): void {
    this.loadCustomersAction({
      resource: RESOURCE_TIME_TRACKING_CUSTOMERS + '/overview',
    });
  }

  created() {
    this.loadCustomersView();
  }

}
